import { useNavigate } from "react-router-dom";
import ForgotPassword from "../../components/layout/ForgotPassword/ForgotPassword";
import "./ForgotPassword.scss";

const ForgotPasswordPage = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/login");
    };

    const handleCancel = () => {
        navigate("/login");
    };

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-page__container">
                <ForgotPassword
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
